import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex mb-x4 xl:mb-x8"
}
const _hoisted_2 = { class: "mr-x2" }

import useProductDetailData from '@/shared/product/details/useProductDetailData';
import CO2EmissionsLogo from '@/shared/product/details/emissions/CO2EmissionsLogo.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductDetailClimateEmissions',
  setup(__props) {

const { climateEmissionsCollection } = useProductDetailData();

return (_ctx: any,_cache: any) => {
  return (_unref(climateEmissionsCollection))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(CO2EmissionsLogo, { class: "h-25" })
        ]),
        _createVNode(_Transition, {
          name: "o-anim-fade-200",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(climateEmissionsCollection).climateEmissions, (emission) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: emission.emissionValue + emission.screeningSpecification
                }, _toDisplayString(emission.emissionValue) + " " + _toDisplayString(emission.screeningSpecification), 1))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})